import { messages as validation } from "vee-validate/dist/locale/en.json";
import { countryList } from "@/locales/properNouns";
import messages from "./json/bg.json";

export default {
  pl: {
    word: "{n} {word} | {n} {word}и",
  },
  validation: {
    ...validation,
    credit_card: "Полето {_field_} трябва да е валиден номер на кредитна карта",
    email: "Невалиден {_field_}",
    required_if: "{_field_} полето е задължително",
    required: "{_field_} полето е задължително",
    required_select: validation.required,
  },
  notificationsText: {
    liked: "{screenName} хареса ваша публикация",
    followed: "{screenName} ви последва",
    subscribed: "{screenName} се абонира за вас за {price}",
    upgradeSubscription: "{screenName} надграждане на абонамента за вас. Сега нивото на абонамента е {price}",
    soldPost: "{screenName} купи публикацията ти за {price}",
    soldAttachment: "{screenName} купи вашия прикачен файл за {price}",
    soldEvent: "{screenName} закупи достъп до вашето събитие {date} for {price}",
    eventPublished: "предстоящо събитие от {screenName}!",
    eventStarted: "събитието започна",
    eventCancelled: "{screenName} събитието приключи",
  },
  ...messages,
  ...countryList,
};
